interface NotFoundPageProps {
  authenticated: boolean
  navigate: (to: string) => void
}

export function NotFoundPage({ authenticated, navigate }: NotFoundPageProps) {
  const destination = authenticated ? '/home' : '/welcome'
  return (
    <section className="not-found-page">
      <p className="not-found-page__eyebrow">404 / OFF ROUTE</p>
      <h1>This stop is not on the list.</h1>
      <p>The link may be old or incomplete. Nothing you saved was changed.</p>
      <button onClick={() => navigate(destination)} type="button">Return to {authenticated ? 'home' : 'welcome'}</button>
    </section>
  )
}
